module.exports = __webpack_public_path__ + "img/4.3e2474b2.png";